import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';

class ProductDiscount implements ng.IController {
    public static inject = [''];
    public onDiscountChange: (message: any) => any;
    public discount?: number = null;
    public variationId: string;
    public isDisabled: boolean;
    public selectedOption: number = 0;
    public value: number = 1;

    public $onInit() {
        this.setState();
    }

    public $onChanges(onChangesObj: angular.IOnChangesObject): void {
        this.setState();
    }

    public setState() {
        if (!this.discount) {
            this.selectedOption = 1;
        }

        if (this.discount && this.discount === 100) {
            this.selectedOption = 2;
        }

        if (this.discount && (this.discount > 0 && this.discount < 100)) {
            this.selectedOption = 3;
            this.value = this.discount;
        }
    }

    public changeDiscountValue() {

        if (!this.value || (this.value > 99 || this.value < 1)) {
            this.value = 1;
            this.discount = this.value;
        } else {
            this.discount = parseInt(this.value.toString(), 10);
        }

        this.sendChangeDiscountMessage();
    }

    public sendChangeDiscountMessage() {
        const message = {
            variationID: this.variationId,
            discount: this.discount
        };
        this.onDiscountChange({discountMessage: message});
    }
}

angular.module('naut').component('productDiscount', {
    template: require('./product-discount.component.html'),
    controller: ProductDiscount,
    controllerAs: 'ctrl',
    bindings: {
        variationId: '<',
        discount: '<',
        isDisabled: '<',
        onDiscountChange: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/products/components/shared/product-discount/product-discount.component.ts